/* Page container - flex column that fills available height */
.fill-height-page {
  display: flex !important;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0; /* Allow shrinking below content size */
  overflow: hidden;
}

/* Header/filter sections - stay their natural height */
.fill-height-header {
  flex-shrink: 0;
}

/* Table fills remaining space */
.fill-height-page > agwa-lit-table {
  flex: 1 1 auto;
  min-height: 0; /* Critical: allows flex item to shrink */
  overflow: hidden;
}

/* Empty states should also flex-fill when shown instead of table */
.fill-height-page > agwa-empty-state {
  flex: 1 1 auto;
  min-height: 200px;
}
